import { AWARD_CODES } from "../enums/award-codes";

export const getBFIAwardCodes = (isoCountryCode: string) => {
  return {
    bfi: isoCountryCode === "MN" ? AWARD_CODES.MN_BRONZE_FOUNDATION : AWARD_CODES.BRONZE_FOUNDATION,
    bfiRestart1: AWARD_CODES.RESTART_BRONZE_FOUNDATION,
    bfiRestart2: AWARD_CODES.RESTART_TWO_BRONZE_FOUNDATION,
    bfiConsistencyPayment: AWARD_CODES.BRONZE_FOUNDATION_FIXED_PAYMENT,
  };
};

export const getBBIAwardCodes = (isoCountryCode: string) => {
  return {
    bbi: isoCountryCode === "MN" ? AWARD_CODES.MN_BRONZE_BUILDER : AWARD_CODES.BRONZE_BUILDER,
    bbiRestart1: AWARD_CODES.RESTART_BRONZE_BUILDER,
    bbiRestart2: AWARD_CODES.RESTART_TWO_BRONZE_BUILDER,
    bbiConsistencyPayment: AWARD_CODES.FIXED_PAYMENT,
  };
};

export const getBronzeAwardCodes = (isoCountryCode: string) => {
  return { ...getBFIAwardCodes(isoCountryCode), ...getBBIAwardCodes(isoCountryCode) };
};
